<template>
  <div class="contend">
    <MENU />
    <MAIN />
  </div>
</template>
<script>
import layout from './js/layout.js'
export default {
  mixins: [layout]
}
</script>
<style lang="scss" scoped>
@import "./css/layout.scss";
</style>
